// Inventaire de réévaluation « actif » (sélectionné par le gestionnaire). Stocké en localStorage
// pour être disponible sur les écrans de réévaluation (global + par garantie) sans threader de props.
// Quand un inventaire OUVERT est actif, les réévaluations s'y rattachent (inventaireCodeId).
const KEY = "poolins_inventaire_actif";

export const getActiveInventaire = () => {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null; // { codeId, titre }
    } catch (e) {
        return null;
    }
};

export const setActiveInventaire = (inv) => {
    try {
        if (inv && inv.codeId) {
            localStorage.setItem(KEY, JSON.stringify({ codeId: inv.codeId, titre: inv.titre || "" }));
        } else {
            localStorage.removeItem(KEY);
        }
    } catch (e) {
        // ignore (mode privé / storage indispo)
    }
};

export const getActiveInventaireCodeId = () => getActiveInventaire()?.codeId || null;
